module.exports = __webpack_public_path__ + "static/media/11.59e3da01.jpg";